import { Link } from 'react-router-dom';
import styles from './CardTourismPoints.module.css';


export default function CardTourismPoints({ id, nome, descricao, url, imagem }) {
  return (
    <div className={styles.container}>
      <Link key={id} to={`/ponto-turistico/${url}`}>
        <div
          className={styles.background}
          style={{ backgroundImage: `url(${imagem})` }}
        />
        <div className={styles.content}>
          <h3>{nome}</h3>
        </div>
      </Link>
    </div>
  )
}
